<div class="sidebar-container" [class.expanded]="isExpanded$ | async">
  <form
    [formGroup]="subTenantForm"
    class="sidebar-header"
    [class.expanded]="isExpanded$ | async"
  >
    <p-multiSelect
      class="w-full"
      [style]="{ width: 'inherit' }"
      inputId="selectedSubTenants"
      *ngIf="isTenantUser && (isExpanded$ | async) && !isAdminPage"
      [options]="allSubTenants"
      formControlName="subTenantsDropdown"
      defaultLabel="Select Originators"
      optionLabel="label"
      [maxSelectedLabels]="1"
    >
      <ng-template let-value pTemplate="selectedItems">
        <div *ngIf="value?.length === 0 || !value || !allSubTenants?.length">
          Select Originators
        </div>
        <div
          *ngIf="
            value?.length > 0 && value?.length === allSubTenants?.length;
            else selectedItems
          "
        >
          All Originators
        </div>
        <ng-template #selectedItems>
          <div *ngIf="value?.length > 0 && allSubTenants?.length">
            {{ value?.length }} Originators selected
          </div>
        </ng-template>
      </ng-template>
    </p-multiSelect>
    <div *ngIf="isExpanded$ | async">
      <h4 *ngIf="isAdminPage" class="sidebar-admin-header">Admin</h4>
    </div>
    <button
      pButton
      icon="pi pi-bars"
      (click)="toggleSidebar()"
      class="p-button-text text-sm"
    ></button>
  </form>

  <div class="sidebar-content">
    <!-- Expanded View -->
    <div
      class="sidebar-content-visibility-trigger"
      [class.expandedVisibility]="(isExpanded$ | async) && !isAdminPage"
    >
      <!-- Funding Panel -->
      <div class="panel mb-2 mx-2">
        <div class="panel-header">
          <div class="flex align-items-center w-full">
            <i
              (click)="togglePanel('funding')"
              [class]="
                isFundingOpen
                  ? 'pi pi-chevron-down mr-2'
                  : 'pi pi-chevron-right mr-2'
              "
            ></i>
            <div class="flex align-items-center gap-2">
              <i class="pi pi-money-bill text-primary text-sm"></i>
              <a
                class="text-primary"
                [routerLink]="'/secure/funding/funding-pipeline'"
                >Funding</a
              >
            </div>
          </div>
        </div>
        <div
          class="panel-content"
          [@panelAnimation]="isFundingOpen ? 'open' : 'closed'"
        >
          <div class="menu-links">
            <a
              *ngFor="let anchor of fundingWorkflowStatusCounts$ | async"
              [routerLink]="'/secure/funding/funding-pipeline'"
              [queryParams]="{ loanStatus: anchor.status }"
              class="menu-link"
            >
              <span>{{ anchor.status }}</span>
              <span class="flex align-items-center justify-content-between w-2">
                <i
                  [class]="
                    anchor.highPriorityIndicator
                      ? 'pi pi-exclamation-circle color-danger text-sm'
                      : ''
                  "
                ></i>
                <span>{{ anchor.count }}</span>
              </span>
            </a>
          </div>
        </div>
      </div>

      <!-- Collateral Panel -->
      <div class="panel my-2 mx-2">
        <div class="panel-header">
          <div class="flex align-items-center w-full">
            <i
              (click)="togglePanel('collateral')"
              [class]="
                isCollateralOpen
                  ? 'pi pi-chevron-down mr-2'
                  : 'pi pi-chevron-right mr-2'
              "
            ></i>
            <div class="flex align-items-center gap-2">
              <i class="pi pi-send text-primary text-sm"></i>
              <a
                class="text-primary"
                [routerLink]="'/secure/collateral/collateral-pipeline'"
                >Collateral</a
              >
            </div>
          </div>
        </div>
        <div
          class="panel-content"
          [@panelAnimation]="isCollateralOpen ? 'open' : 'closed'"
        >
          <div class="menu-links">
            <a
              *ngFor="let anchor of collateralWorkflowStatusCounts$ | async"
              [routerLink]="'/secure/collateral/collateral-pipeline'"
              [queryParams]="
                anchor.eNote
                  ? {
                      workflowStatus: anchor.workflowStatus,
                      eNote: anchor.eNote
                    }
                  : { workflowStatus: anchor.workflowStatus }
              "
              class="menu-link"
            >
              <span>{{ anchor.status }}</span>
              <span>{{ anchor.count }}</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Settlement Panel -->
      <div class="panel my-2 mx-2">
        <div class="panel-header">
          <div class="flex align-items-center w-full">
            <i
              (click)="togglePanel('settlement')"
              [class]="
                isSettlementOpen
                  ? 'pi pi-chevron-down mr-2'
                  : 'pi pi-chevron-right mr-2'
              "
            ></i>
            <div class="flex align-items-center gap-2">
              <i class="pi pi-dollar text-primary text-sm"></i>
              <a
                class="text-primary"
                [routerLink]="'/secure/settlement/settlement-landing'"
                >Settlement</a
              >
            </div>
          </div>
        </div>
        <div
          class="panel-content"
          [@panelAnimation]="isSettlementOpen ? 'open' : 'closed'"
        >
          <div class="menu-links">
            <a
              *ngFor="let anchor of settlementWorkflowStatusCounts$ | async"
              [routerLink]="'/secure/settlement/settlement-landing'"
              [queryParams]="{ workflowStatus: anchor.workflowStatus }"
              class="menu-link"
            >
              <span>{{ anchor.status }}</span>
              <span>{{ anchor.count }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isAdminPage">
      <app-admin-sidebar-menu
        [isSidebarExpanded]="(isExpanded$ | async) || false"
      ></app-admin-sidebar-menu>
    </div>

    <!-- Collapsed View -->
    <div
      *ngIf="(isExpanded$ | async) === false && !isAdminPage"
      class="collapsed-view"
    >
      <div class="icon-links">
        <a
          *ngFor="let anchor of mainSectionAnchors"
          [routerLink]="anchor.route"
          class="icon-link"
          [pTooltip]="anchor.label"
        >
          <i [class]="anchor.icon + ' text-sm'"></i>
        </a>
      </div>
    </div>
  </div>
</div>
